import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaisedancab() {



const cardData = {
  keyword: " Pune to Mumbai Sedan Cab ",

headingDescription:
  "Velocity Cab provides Pune to Mumbai Sedan cab services, offering a comfortable, stylish, and convenient travel option for individuals, families, and business travelers. Our professional drivers, well-maintained sedan vehicles, and punctual pickups ensure a smooth and hassle-free journey from Pune to Mumbai. We provide flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Pune to Mumbai Sedan cab travel.",

topPlaces: [

  {
    title: "Phoenix Marketcity",
    description: "Phoenix Marketcity is one of Mumbai's premier shopping and entertainment destinations, featuring luxury brands, restaurants, gaming zones, and multiplex cinemas. Travelers hiring an Innova Crysta on rent in Pune can spend an enjoyable day shopping, dining, and relaxing with family and friends in this modern lifestyle destination."
  },
  {
    title: "Bandra Bandstand",
    description: "Bandra Bandstand is a scenic seaside promenade offering spectacular views of the Arabian Sea and the Bandra-Worli Sea Link. Travelers booking an Innova Crysta on rent in Pune can enjoy a relaxing drive before taking peaceful walks, visiting nearby cafés, and exploring one of Mumbai's most popular waterfront locations."
  },
  {
    title: "Kanheri Caves",
    description: "Kanheri Caves are ancient Buddhist rock-cut monuments located inside Sanjay Gandhi National Park. Visitors choosing an Innova Crysta on rent in Pune can comfortably reach this historic destination and explore centuries-old caves, sculptures, meditation halls, and lush green surroundings ideal for history lovers and adventure seekers."
  },
    {
    title: "Mahalakshmi Temple",
    description: "Mahalakshmi Temple is one of Mumbai's oldest and most revered Hindu temples, attracting thousands of devotees throughout the year. Travelers booking an Innova Crysta on rent in Pune can enjoy a comfortable journey to this sacred destination while exploring its beautiful architecture, peaceful surroundings, and nearby coastal viewpoints. It is an excellent place for spiritual visits and cultural exploration."
  },
  {
    title: "Gilbert Hill",
    description: "Gilbert Hill is a rare volcanic rock formation estimated to be over 66 million years old. Visitors choosing an Innova Crysta on rent in Pune can comfortably explore this unique geological landmark and enjoy panoramic views of Mumbai from the hilltop temple. It is a hidden gem perfect for photography and sightseeing."
  },
  {
    title: "Gateway of India",
    description: "Gateway of India is Mumbai's most celebrated landmark, overlooking the Arabian Sea. Renting an Innova Crysta in Pune makes the road trip convenient for families and groups planning a memorable sightseeing experience. Visitors can admire the monument's architecture, enjoy ferry rides, and explore nearby heritage attractions in South Mumbai."
  },
  {
    title: "Worli Sea Face",
    description: "Worli Sea Face is a beautiful waterfront promenade where visitors can enjoy cool sea breezes, scenic views, and spectacular sunsets. Renting an Innova Crysta in Pune ensures a comfortable road trip for families and groups looking to relax by Mumbai's coastline and capture memorable photographs."
  },
  {
    title: "Taraporewala Aquarium",
    description: "Taraporewala Aquarium is one of India's oldest aquariums, showcasing a fascinating variety of marine and freshwater species. Travelers hiring an Innova Crysta on rent in Pune can conveniently visit this family-friendly attraction, making it an enjoyable destination for children, students, and marine life enthusiasts."
  },
  {
    title: "Crawford Market",
    description: "Crawford Market is a historic shopping destination famous for fresh produce, spices, dry fruits, handicrafts, and imported goods. Booking an Innova Crysta on rent in Pune allows visitors to comfortably explore this vibrant marketplace while experiencing Mumbai's rich local culture and colonial architecture."
  },
  {
    title: "Marine Drive",
    description: "Marine Drive, popularly known as the Queen's Necklace, is one of Mumbai's most iconic coastal roads. Travelers choosing an Innova Crysta on rent in Pune can enjoy a scenic journey before relaxing along the promenade, watching the sunset over the Arabian Sea, and experiencing the lively atmosphere that makes Marine Drive a favorite among visitors."
  }
],



services: [
{
name: "Pune to Mumbai Sedan Cab",
description: "Pune to Mumbai sedan cab service offers comfortable and economical transportation between Pune and Mumbai. Sedan cars like Swift Dzire, Etios, and Xcent provide smooth highway travel suitable for business trips, airport transfers, and family journeys. Professional drivers ensure safe expressway travel with punctual pickup services across Pune."
},
{
name: "Pune to Mumbai Swift Dzire Cab",
description: "Pune to Mumbai Swift Dzire cab service provides affordable and reliable sedan transportation between Pune and Mumbai. The Swift Dzire offers comfortable seating for 4 passengers and smooth highway performance. Professional drivers ensure safe driving and timely pickup services."
},
{
name: "Pune to Mumbai Etios Cab Booking",
description: "Pune to Mumbai Etios cab booking service provides economical sedan transportation for passengers traveling between Pune and Mumbai. The Toyota Etios offers comfortable seating and fuel-efficient highway travel suitable for long-distance journeys."
},
{
name: "Pune to Mumbai Xcent Cab Booking",
description: "Pune to Mumbai Xcent cab booking service offers reliable sedan transportation between Pune and Mumbai. The Hyundai Xcent provides comfortable seating and smooth expressway travel suitable for business travel and family trips."
},
{
name: "Pune to Mumbai Airport Sedan Cab",
description: "Pune to Mumbai Airport sedan cab service provides dependable airport transportation using comfortable 4-seater vehicles. Sedan cars offer smooth highway travel and luggage space suitable for airport transfers to Mumbai Airport terminals."
},
{
name: "Pune to Dadar Sedan Cab",
description: "Pune to Dadar sedan cab service provides reliable transportation between Pune and Dadar in Mumbai. Comfortable sedan vehicles ensure safe and smooth expressway travel with professional drivers."
},
{
name: "Pune to Andheri Sedan Cab",
description: "Pune to Andheri sedan cab service offers convenient transportation between Pune and Mumbai’s Andheri area. Sedan vehicles provide comfortable seating and smooth highway travel suitable for business trips."
},
{
name: "Pune to Mumbai One Way Sedan Cab",
description: "Pune to Mumbai one way sedan cab service offers convenient single-trip transportation between Pune and Mumbai. Sedan cars provide economical and comfortable expressway travel with professional drivers."
},
{
name: "Pune to Mumbai Airport Sedan Cab",
description: "Pune to Mumbai Airport sedan cab service provides dependable airport transportation using comfortable sedan vehicles. Professional drivers ensure safe expressway travel and timely airport drop services."
},
{
name: "Pune to Mumbai Cab Round Trip",
description: "Pune to Mumbai cab round trip service provides convenient travel options for passengers planning return journeys between Pune and Mumbai. Comfortable vehicles and experienced drivers ensure safe expressway travel."
},
{
name: "Pune to Mumbai Swift Dzire Cab Booking Online",
description: "Pune to Mumbai Swift Dzire cab booking online service allows travelers to easily reserve sedan taxis for expressway travel. The vehicle offers comfortable seating and smooth highway travel suitable for business trips and family journeys."
},
{
name: "Pune to Mumbai Etios Cab",
description: "Pune to Mumbai Etios cab service offers economical sedan transportation between Pune and Mumbai. The Toyota Etios provides comfortable seating and smooth highway travel performance."
},
{
name: "Pune to Mumbai 5 Seater Cab",
description: "Pune to Mumbai 5 seater cab service offers comfortable sedan transportation suitable for families and small groups. Vehicles provide spacious seating and luggage capacity for highway travel."
},
{
name: "Pune to Mumbai 4 Seater Cab",
description: "Pune to Mumbai 4 seater cab service provides economical sedan transportation for passengers traveling between Pune and Mumbai. The vehicles are comfortable and suitable for expressway travel."
},
{
name: "Pune to Mumbai Central Sedan Cab Service",
description: "Pune to Mumbai Central sedan cab service offers reliable transportation for travelers heading to Mumbai Central railway station. Sedan vehicles ensure comfortable expressway travel with professional drivers."
},
{
name: "Pune to Dadar Sedan Cab",
description: "Pune to Dadar sedan cab service provides dependable transportation between Pune and Mumbai’s Dadar area. Sedan vehicles offer smooth highway travel suitable for business trips and family journeys."
},
{
name: "Velocity Cabs Pune",
description: "Velocity Cabs Pune provides reliable transportation services for city travel, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe and smooth travel experiences."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune offers dependable transportation for local travel, airport transfers, and outstation journeys. Vehicles are comfortable and suitable for city rides and long-distance travel."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai Airport cab service provides reliable transportation from Pune to Mumbai Airport terminals. Comfortable vehicles and professional drivers ensure safe expressway travel with timely airport drop services."
}
],

tableData: [
["Pune to Mumbai Sedan Cab","Pune to Mumbai Swift Dzire Cab"],
["Pune to Mumbai Etios Cab Booking","Pune to Mumbai Xcent Cab Booking"],
["Pune to Mumbai Airport Sedan Cab","Pune to Dadar Sedan Cab"],
["Pune to Andheri Sedan Cab","Pune to Mumbai One Way Sedan Cab"],
["Pune to Mumbai Airport Sedan Cab","Pune to Mumbai Cab Round Trip"],
["Pune to Mumbai Swift Dzire Cab Booking Online","Pune to Mumbai Etios Cab"],
["Pune to Mumbai 5 Seater Cab","Pune to Mumbai 4 Seater Cab"],
["Pune to Mumbai Central Sedan Cab Service","Pune to Dadar Sedan Cab"],
["Velocity Cabs Pune","Cab Service in Pune"],
["Pune to Mumbai Airport Cab","Pune to Mumbai Sedan Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Comfortable Sedan Travel Experience",
    WhyChoosedescription: "Velocity Cabs offers smooth and comfortable sedan cab services for Pune to Mumbai travel. Sedan cars like Swift Dzire and Toyota Etios provide excellent mileage, spacious seating, and a relaxed highway journey for passengers."
  },
  {
    WhyChooseheading: "Experienced Mumbai Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides skilled drivers who regularly drive on the Mumbai Pune Expressway. Their knowledge of traffic routes and expressway driving ensures safe and timely travel between Pune and Mumbai."
  },
  {
    WhyChooseheading: "Affordable Sedan Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers competitive and transparent pricing for Pune to Mumbai sedan cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Sedan Cab Availability",
    WhyChoosedescription: "Our Pune to Mumbai sedan cab service operates 24 hours a day. Whether you need an early morning ride, airport transfer, or late-night drop, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Well Maintained Vehicles",
    WhyChoosedescription: "All sedan vehicles in the Velocity Cabs fleet are air-conditioned, regularly serviced, and cleaned before every trip to provide a comfortable and hygienic travel experience."
  },
  {
    WhyChooseheading: "Ideal for Business & Family Travel",
    WhyChoosedescription: "Sedan cabs are ideal for solo travelers, couples, business professionals, and small families traveling between Pune and Mumbai with comfortable seating and luggage space."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "Velocity Cabs provides doorstep pickup from homes, offices, hotels, and railway stations across Pune including Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, and Pimpri Chinchwad."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by travelers for Pune to Mumbai sedan cab bookings thanks to punctual drivers, comfortable vehicles, and reliable intercity transportation service."
  }
]
};

const faqData = [
  { question: "Do you provide Pune to Mumbai sedan cab service?", answer: "Yes, Velocity Cabs provides comfortable and affordable sedan cab services from Pune to Mumbai." },
  { question: "Which sedan cars are available for this route?", answer: "Velocity Cabs offers sedan cars such as Swift Dzire, Toyota Etios, and similar vehicles for Pune to Mumbai travel." },
  { question: "Is Pune to Mumbai sedan cab available 24 hours?", answer: "Yes, our sedan cab service operates 24/7 to match customer travel schedules." },
  { question: "Can I book a one-way sedan cab from Pune to Mumbai?", answer: "Yes, Velocity Cabs provides both one-way and round-trip sedan cab services between Pune and Mumbai." },
  { question: "How many passengers can travel in a sedan cab?", answer: "A sedan cab can comfortably accommodate up to 4 passengers with luggage." },
  { question: "Do you provide pickup from Pune Airport or railway station?", answer: "Yes, our drivers provide pickup from Pune Airport, railway stations, homes, hotels, and offices across Pune." },
  { question: "Are sedan vehicles air-conditioned?", answer: "Yes, all sedan vehicles provided by Velocity Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can I book Pune to Mumbai sedan cab online?", answer: "Yes, customers can easily book sedan cabs online or through phone booking with Velocity Cabs." },
  { question: "Do you provide Mumbai Airport drop?", answer: "Yes, Velocity Cabs provides direct drop services to Mumbai Airport and other locations across Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback:
      "Pune to Mumbai sedan cab service with Velocity Cab was very comfortable and smooth. The car was clean, well-maintained, and the journey felt safe and relaxing throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Deshmukh",
    feedback:
      "The Pune to Mumbai sedan cab ride with Velocity Cab was excellent. The driver was professional, and the trip was punctual, hassle-free, and very comfortable.",
    rating: 5
  }
];






































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Sedan Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides Pune to Mumbai Sedan cab service with affordable fares and professional drivers. Book one way and round trip taxis including Swift Dzire, Etios, and Xcent for airport transfers, Dadar, Andheri, Mumbai Central, and other destinations. Enjoy safe, comfortable, and punctual rides with easy online booking from Pune to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};







  return (
    <div>
      <Helmet>
  <title>Pune to Mumbai Sedan Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai Sedan cab with Velocity Cabs. Affordable one way, round trip & airport drop taxis including Swift Dzire, Etios & Xcent for Dadar, Andheri, Mumbai Central & Mumbai airport." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/22.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaisedancab;